<template>
  <div class="w-full h-full px-4 overflow-y-auto sm:px-6 md:px-8">
    <div class="h-full mt-8">
      <div class="mt-20 flex w-full flex-col">
        <div class="flex justify-center w-full">
          <div
            class="my-4 min-h-[230px] text-center justify-center max-w-4xl w-full border border-dashed rounded-md border-light-divider-blue dark:border-dark-divider-border">
            <div class="relative flex flex-col justify-center">
              <input
                class="custom-file-input"
                accept=".xlsx,.xls,.csv,.numbers"
                type="file"
                @change="
                  ($event) => {
                    uploadFileAndGetInfo($event.target.files[0])
                  }
                ">
              <CloudUpload class="mx-auto pt-2 my-1/2 mt-[15px] mb-[28px]" color="#899399" />
              <span class="mx-auto dark:text-dark-body-text">{{ $t("Drag & drop spreadsheet") }}</span>
              <span class="mx-auto text-sm dark:text-dark-search-bar-text">{{ $t("CSV, XSLS and Numbers are supported") }}</span>
              <span class="z-10 mx-auto dark:text-dark-body-text">{{ $t("Or") }}
                <a href="/RevSetter CSV Template.xlsx" class="text-blue"> {{ $t("download this template") }} </a>
              </span>
              <span
                v-if="$store.state.integration.integrations.find((i) => i.reference == 'google-drive')"
                class="z-10 mx-auto mt-2 dark:text-dark-body-text">{{ $t("Or") }}
                <span class="mx-auto dark:text-dark-body-text"> {{ $t("Provide a Google Sheet link") }}</span>
                <div class="flex">
                  <input
                    v-model="sheet_link"
                    class="h-10 m-0 rounded-r-none form-input"
                    type="text"
                    :placeholder="$t('Type your Google Sheet URL')">
                  <button
                    :disabled="!sheet_link"
                    class="w-24 m-0 rounded-l-none primary-outline-btn"
                    @click="
                      () => {
                        uploadLinkAndGetInfo(sheet_link)
                      }
                    ">
                    {{ $t("Upload") }}
                  </button>
                </div>
              </span>
              <button class="w-24 mx-auto my-8 primary-outline-btn">{{ $t("Upload file") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CloudUpload } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import DataService from "@/services/data.service"
export default {
  name: "UploadSheet",
  components: {
    CloudUpload
  },

  data() {
    return {
      sheet_link: null
    }
  },

  methods: {
    uploadFileAndGetInfo(uploaded_file) {
      this.$emitter.emit(ALL_EMITTERS.SPREADSHEET_IS_LOADED_IN_ADMIN_CONTAINER, false)
      this.$emitter.emit(ALL_EMITTERS.SPREAD_SHEET_IS_LOADED_IN_ONBOARDING_CONTAINER, false)

      this.$store.dispatch("ui/showLoading")
      DataService.signS3PostRequest({
        file_name: uploaded_file.name,
        create_integration: true
      })
        .then((result) => {
          let data = result.data
          return DataService.uploadFileToS3(data.url, uploaded_file).then(() => {
            this.$router.push(`/admin/integrations/spreadsheet/${data.integration_id}/object-selection/`)
          })
        })
        .catch(() => {
          this.$emitter.emit(ALL_EMITTERS.SPREADSHEET_IS_LOADED_IN_ADMIN_CONTAINER, false)
          this.$emitter.emit(ALL_EMITTERS.SPREAD_SHEET_IS_LOADED_IN_ONBOARDING_CONTAINER, false)

          this.$store.dispatch("ui/hideLoading")
        })
    },
    uploadLinkAndGetInfo(link) {
      this.$emitter.emit(ALL_EMITTERS.SPREADSHEET_IS_LOADED_IN_ADMIN_CONTAINER, false)
      this.$emitter.emit(ALL_EMITTERS.SPREAD_SHEET_IS_LOADED_IN_ONBOARDING_CONTAINER, false)

      this.$store.dispatch("ui/showLoading")

      DataService.uploadLinkToS3({ file_url: link }).then((res) => {
        this.$router.push(`/admin/integrations/spreadsheet/${res.data.integration_id}/object-selection/`)
      })
    }
  }
}
</script>

<style>
.custom-file-input {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  background-color: transparent;
  resize: none;
  outline: none;
  cursor: pointer;
}
</style>
